module.exports = {"420202005":"沈家营街道","420202006":"黄石港街道","420202007":"胜阳港街道","420202070":"花湖街道","420202400":"江北管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420202.json
// module id = 1834
// module chunks = 0